import { FC } from 'react'
import { Error } from './Error'

const maxLength = 150
export const Textarea: FC<{
  value: string
  onChange: (val: string) => void
}> = ({ onChange, value }) => {
  const isLengthTooLong = value.length > maxLength
  return (
    <div className="flex w-[450px] flex-col items-center">
      {isLengthTooLong && (
        <div
          className="ml-auto flex items-center justify-center gap-xxxs text-sm leading-[13px] text-gray-900"
          data-testid="char-count"
        >
          <Error>{value.length}</Error>/
          <span className="text-gray-400">{maxLength}</span>
        </div>
      )}
      <textarea
        placeholder="I&rsquo;m a very good person, I like cars and people..."
        className="min-h-[128px] w-[450px] rounded-m border-2 border-blue-600 px-s py-[14px]"
        maxLength={maxLength + 1}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}
